import type { AnyEventObject } from 'xstate';
import { actions } from './actions';

export const events = {
  on: {
    UPDATE_GUARDS: {
      actions: actions.updateContextGuards
    }
  },
  always: {
    actions: actions.navigate,
    guard: ({ event }: { event: AnyEventObject }) => {
      return !event.type.includes('xstate') && event.type !== 'UPDATE_GUARDS';
    }
  }
};
